import { createApp } from 'vue'
import FloatingVue from 'floating-vue'

// Importação do App e router
import App from './App.vue'
import router from './router'

// Importação das configurações dos plugins
import pinia from '@/plugins/pinia'
import { i18n } from '@/plugins/i18n'

// Importação dos estilos globais
import '@/assets/scss/global.scss'
import 'floating-vue/dist/style.css'
import '@/assets/scss/icons.scss'

import PrimeVue from 'primevue/config'

// Importação dos estilos do PrimeVue (versão simplificada)
import 'primeicons/primeicons.css'

// Criação da aplicação
const app = createApp(App)

// Registro dos plugins
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(FloatingVue)

app.use(PrimeVue)

// Montagem da aplicação
app.mount('#app')
